export default __webpack_public_path__ + "static/media/DNo.20-5.fe11bf81.jpg";